import { typography, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

import { SelectTabLine } from '../select-tab-line/SelectTabLine';

export const Legend = styled.div`
  display: flex;
  margin-top: 16px;
`;

export const ButtonLayoutWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: right;
  margin: 24px 20px;
  & button {
    margin-left: 8px;
  }
`;

export const TabLines = styled(SelectTabLine)`
  header {
    padding-top: 10px;
  }
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  margin-right: 16px;
`;

export const Label = styled.div`
  ${typographyV2.bodyXs};
`;

export const Marker = styled.div`
  width: 13px;
  height: 0;
  margin-right: 4px;
  border-top: 2px solid currentColor;
`;

export const BullishMarker = styled(Marker)`
  border-top-style: dashed;
  border-top-color: var(--viz-bullish);
`;

export const BearishMarker = styled(Marker)`
  border-top-style: dashed;
  border-top-color: var(--viz-bearish);
`;

export const Footer = styled.div`
  ${typographyV2.bodySm};
  color: var(--text-soft);
  margin-top: 16px;
`;

export const ExternalLink = styled.a`
  margin-left: 4px;
  color: var(--text-link);
  white-space: nowrap;
  display: inline-flex;
  align-items: center;

  &:hover {
    color: var(--text-link);
    text-decoration: underline;
  }
`;

export const OverlayText = styled.p`
  ${typographyV2.bodySm};
  color: var(--text-primary);
  opacity: 0;
  z-index: 1;
  pointer-events: none;
  padding: 8px;
  background-color: var(--background-backdrop);
  border-radius: 10px;
`;

export const LockButton = styled.button`
  position: absolute;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  ${typography.quokka};
  border: 0;
  background: 0;
  cursor: pointer;
  outline: none;

  &:after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: var(--surface-default);
    border-radius: 8px;
    opacity: 0.8;
  }
`;

export const Overlay = styled.div`
  display: flex;
  position: absolute;
  bottom: -8px;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  cursor: pointer;

  &:hover ${OverlayText} {
    opacity: 1;
  }
`;

export const IconWrapper = styled.div`
  z-index: 1;
  & > svg {
    fill: var(--icon-primary);
  }
`;
